const cityFormatted = (city, state, zip) => {
  if (!city) {
    return `${state} ${zip}`;
  }

  if (!state) {
    return `${city} ${zip}`;
  }

  if (!zip) {
    return `${city}, ${state}`;
  }

  return `${city}, ${state} ${zip}`;
}

export const addressFormatter = (address) => {
  const {
    address_1,
    address_2,
    city,
    county,
    state,
    zip,
  } = address;
  if (!address_1 && !address_2 && !city && !state && !zip && !county) {
    return null;
  }

  if (!address_1 && !address_2 && !city && !state && !zip) {
    return county;
  }

  if (!address_2) {
    return `${address_1} ${cityFormatted(city, state, zip)}`;
  }

  return `${address_1} ${address_2} ${cityFormatted(city, state, zip)}`;
}